import { Icon as ChakraIcon, forwardRef } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

const BrushIcon = forwardRef((props, ref) => {
    const { darkMode } = useSelector((state) => state.settings);
    return (
        <ChakraIcon
            viewBox="0 0 512 512"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            focusable="false"
            {...props}
            ref={ref}
            boxSize={5}>
            <g
                transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                stroke="none"
                fill={darkMode ? 'rgba(255,255,255,1)' : 'rgba(117,117,117,1)'}>
                <path d="M4235 5103 c-143 -30 -266 -97 -371 -202 -37 -36 -225 -295 -503 -691 -454 -647 -475 -673 -558 -701 -48 -15 -169 -7 -212 15 -18 10 -109 91 -201 181 -218 213 -284 248 -470 248 -103 0 -163 -14 -251 -58 -70 -35 -485 -444 -497 -490 -21 -73 -55 -36 1071 -1162 1126 -1126 1089 -1092 1162 -1071 46 12 455 427 490 497 44 88 58 148 58 251 0 187 -35 253 -250 472 -187 190 -208 224 -207 328 0 74 26 139 72 183 15 15 307 222 647 462 350 245 646 460 681 493 215 210 281 526 168 802 -136 328 -488 516 -829 443z m296 -481 c139 -72 162 -266 44 -370 -75 -66 -163 -79 -250 -38 -60 28 -87 56 -114 116 -37 81 -23 171 38 241 70 83 183 103 282 51z" />
                <path
                    fill="currentColor"
                    d="M1004 3044 c-17 -8 -231 -216 -476 -462 -493 -495 -495 -497 -519 -650 -27 -166 25 -293 192 -466 107 -112 154 -146 200 -146 19 0 356 176 438 229 29 19 38 38 -105 -221 -58 -103 -107 -200 -110 -216 -4 -18 0 -43 10 -64 9 -19 220 -237 479 -495 435 -433 466 -462 537 -497 141 -69 282 -70 420 -4 58 28 112 78 512 476 247 246 455 461 464 480 37 79 91 19 -954 1064 -526 527 -971 965 -988 973 -40 19 -61 19 -100 -1z"
                />
            </g>
        </ChakraIcon>
    );
});

export { BrushIcon };

const Icon = forwardRef((props, ref) => {
    return <ChakraIcon {...props} ref={ref} boxSize={5} />;
});

export default Icon;
